import { render, staticRenderFns } from "./BasicKPI.vue?vue&type=template&id=a2d13ae6&scoped=true&"
import script from "./BasicKPI.vue?vue&type=script&lang=js&"
export * from "./BasicKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d13ae6",
  null
  
)

export default component.exports